import { render, staticRenderFns } from "./NewIncidenceCommentForm.vue?vue&type=template&id=4da3b404&"
import script from "./NewIncidenceCommentForm.vue?vue&type=script&lang=js&"
export * from "./NewIncidenceCommentForm.vue?vue&type=script&lang=js&"
import style0 from "./NewIncidenceCommentForm.vue?vue&type=style&index=0&id=4da3b404&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports